import * as yup from 'yup';

export interface CvsFeeScheduleFormValues {
  paymentType: string;
  price: number | null;
  upc: string;
  charge: string;
  daysSupply: string;
  description: string;
}

export const DEFAULT_CVS_FEE_SCHEDULE_FORM_VALUES: CvsFeeScheduleFormValues = {
  paymentType: '',
  price: null,
  upc: '',
  charge: '',
  daysSupply: '',
  description: '',
};

export const chargeToDisplayValue = (charge: string): number =>
  parseInt(charge, 10) / 100;

export const displayValueToCharge = (dollars: string): string => {
  const cents = Math.round(parseFloat(dollars) * 100);
  return String(cents).padStart(8, '0');
};

export const daysSupplyToDisplayValue = (stored: string): string => {
  const num = parseInt(stored, 10);
  return isNaN(num) ? stored : String(num);
};

export const displayValueToDaysSupply = (input: string): string =>
  String(parseInt(input, 10)).padStart(3, '0');

const required = (field: string): string => `${field} is required`;
const invalidNumber = (field: string): string =>
  `${field} must be a valid number`;

export const cvsFeeScheduleFormSchema = yup.object({
  paymentType: yup.string().defined(),
  price: yup
    .number()
    .nullable()
    .typeError(invalidNumber('CVS Price'))
    .required(required('CVS Price'))
    .min(0, invalidNumber('CVS Price'))
    .test(
      'is-finite',
      invalidNumber('CVS Price'),
      value => value == null || isFinite(value),
    ),
  upc: yup.string().trim().required(required('UPC')),
  charge: yup
    .string()
    .trim()
    .required(required('AWP'))
    .test('is-valid-number', invalidNumber('AWP'), value => {
      if (!value) {
        return false;
      }

      const num = Number(value);

      return !isNaN(num) && isFinite(num) && num >= 0;
    })
    .test(
      'max-charge',
      'AWP must be $999,999.99 or less',
      value => !value || Number(value) <= 999999.99,
    ),
  daysSupply: yup
    .string()
    .trim()
    .required(required('Days supply'))
    .matches(/^\d+$/, 'Days supply must be a whole number'),
  description: yup.string().defined(),
}) as yup.ObjectSchema<CvsFeeScheduleFormValues>;
